import { useEffect } from 'react'

import { Resource } from '@/clients/utoniq-core/schema'
import { TheoPlayerView } from '@/components/organisms/resourcePlayer/TheoPlayerView'
import { useDRMPlayer } from '@/core/resources/useDRMPlayer'

import { VoicePlayerControl } from './VoicePlayerControl'

type Props = {
  resource?: Resource
  bgcolor?: string
  color?: string
}

export const VoiceDRMPlayer = ({ resource, bgcolor, color }: Props) => {
  const { player, ref } = useDRMPlayer({
    source: {
      dashUri: resource?.dashUri || '',
      hlsUri: resource?.hlsUri || '',
    },
    opts: {
      chromeless: true,
    },
  })

  useEffect(() => {
    /**
     * @note
     * DRMの復号処理はplayメソッドに応じて呼び出されるため、マウント時に自動再生→即停止することで音声の事前ロードを行う
     */
    if (!player) return
    player.play()
    player.pause()
  }, [player])

  return (
    <>
      <TheoPlayerView ref={ref} chromeless />
      {player && (
        <VoicePlayerControl
          playing={!(player.paused || player.ended)}
          onClickPause={() => player.pause()}
          onClickPlay={() => player.play()}
          bgcolor={bgcolor}
          color={color}
        />
      )}
    </>
  )
}
